import styled from 'styled-components/macro';

import { sizes } from '../../styles/vars';

const Wrapper = styled.div`
  overflow-y: auto;
  display: block;
  width: 100%;
  height: 275px;
  padding: ${sizes.blockPaddingY};
  background-color: #1a1616;
`;

export default Wrapper;
